var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 202,
    viewBox: "0 0 202 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 15"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy 3",
    opacity: 0.202683,
    cx: 101,
    cy: 101,
    r: 101,
    transform: "matrix(-1 0 0 1 202 0)",
    fill: "url(#paint0_linear_575_2703)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sydney__flatline 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sydney__flatline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M163.347 100.866H177.883C177.883 100.866 187.421 120.536 189.299 128.964H163.347V100.866Z",
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.346 129.231H189.299C189.38 129.232 189.458 129.195 189.509 129.132C189.558 129.068 189.577 128.985 189.561 128.906C187.695 120.512 178.221 100.947 178.122 100.75C178.08 100.656 177.986 100.597 177.883 100.599H163.346C163.198 100.599 163.078 100.718 163.078 100.866V128.964C163.078 129.111 163.198 129.231 163.346 129.231ZM188.966 128.702H163.632L163.615 101.128H177.714C178.589 102.947 187.041 120.623 188.966 128.702Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M164.321 122.477L175.666 127.493C175.666 127.493 165.691 84.4806 146.208 65.0669C146.208 65.0669 139.401 70.2981 134.489 83.8703C133.241 87.3171 134.302 85.1491 134.221 85.7303L132.896 95.1059L164.321 122.477Z",
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.562 127.761C175.597 127.766 175.632 127.766 175.667 127.761C175.731 127.76 175.792 127.737 175.842 127.697C175.918 127.633 175.952 127.532 175.929 127.435C175.83 127.005 165.709 84.1495 146.395 64.8811C146.295 64.7923 146.145 64.7923 146.045 64.8811C145.975 64.9334 139.121 70.3157 134.238 83.8007C133.463 85.9501 133.533 85.992 133.754 86.1255L133.754 86.1257C133.797 86.1515 133.845 86.1674 133.894 86.1722L132.611 95.0596C132.598 95.1498 132.634 95.24 132.704 95.2979L164.128 122.698C164.146 122.717 164.168 122.731 164.193 122.739L175.562 127.761ZM175.299 127.034L164.467 122.25L133.177 94.9433L134.501 85.7421C134.545 85.5933 134.48 85.4338 134.343 85.3585H134.273C134.304 85.2719 134.343 85.1568 134.391 85.0135C134.478 84.7526 134.596 84.3982 134.758 83.9519C139.138 71.8154 145.1 66.3632 146.208 65.4216C164.152 83.5101 174.086 122.093 175.299 127.034Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M134.775 91.5665C134.775 91.5665 137.884 76.9073 146.342 68.7466C146.342 68.7466 159.374 79.7903 171.974 124.012L131.012 121.739C131.012 121.739 131.817 99.2622 134.775 91.5665Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.012 122.03L171.974 124.302C172.069 124.328 172.171 124.301 172.242 124.232C172.302 124.159 172.322 124.061 172.295 123.971C159.811 80.1447 146.704 68.6708 146.57 68.5604C146.46 68.4577 146.289 68.4577 146.179 68.5604C137.884 76.5409 134.658 90.8397 134.512 91.5023C131.597 99.1009 130.784 120.523 130.739 121.706L130.738 121.727C130.731 121.886 130.853 122.02 131.012 122.03ZM171.583 123.704L131.333 121.466C131.421 118.833 132.325 98.7679 135.061 91.6709V91.6244C135.09 91.479 138.181 77.1919 146.348 69.1474C147.118 69.8798 150.128 72.9488 154.211 79.9877C158.581 87.4859 165.126 101.145 171.583 123.704Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M120.991 104.214C120.991 104.214 127.851 89.9444 136.367 81.6616C136.367 81.6616 147.118 90.0665 154.118 99.0642C161.118 108.062 167.535 124.011 167.535 124.011H121.615L120.991 104.214Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.615 124.302H167.541L167.511 124.279C167.608 124.28 167.699 124.233 167.753 124.154C167.808 124.075 167.82 123.974 167.786 123.884C167.739 123.744 161.264 107.795 154.322 98.8902C147.602 90.269 137.305 82.0783 136.561 81.4862C136.536 81.4667 136.522 81.4554 136.519 81.4527C136.409 81.3563 136.244 81.3563 136.134 81.4527C127.85 89.5297 121.018 103.437 120.709 104.065C120.704 104.077 120.7 104.084 120.699 104.087C120.69 104.131 120.69 104.176 120.699 104.22L121.323 124.023C121.329 124.179 121.458 124.303 121.615 124.302ZM167.109 123.721H121.895L121.288 104.278C121.298 104.259 121.31 104.234 121.325 104.205C122.06 102.736 128.535 89.7934 136.391 82.0455C137.896 83.2487 147.515 91.0491 153.891 99.2447C160.109 107.272 166.053 121.193 167.109 123.721Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M136.251 84.5039C136.251 84.5039 126.976 93.2227 123.575 105.15C123.575 105.15 163.364 119.152 163.008 118.803C162.652 118.455 157.099 105.894 150.758 98.5411C141.792 88.1309 136.251 84.5039 136.251 84.5039Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.151 112.323C159.66 118.083 162.495 119.053 163.078 119.053C163.201 119.053 163.23 119.013 163.253 118.96C163.329 118.852 163.317 118.706 163.224 118.612C163.148 118.513 162.816 117.844 162.431 117.066L162.413 117.029C160.489 113.167 156.027 104.207 150.991 98.3493C142.09 88.003 136.466 84.3005 136.408 84.2656C136.295 84.1903 136.146 84.2023 136.046 84.2946C135.953 84.3818 126.678 93.1994 123.295 105.069C123.249 105.216 123.329 105.373 123.476 105.423C123.476 105.423 133.305 108.882 143.151 112.323ZM162.431 118.356C158.388 117.083 136.181 109.306 123.931 104.987C127.075 94.2631 135.026 86.1198 136.291 84.8991C137.341 85.6315 142.638 89.5317 150.566 98.7445C155.557 104.542 159.998 113.472 161.908 117.314L161.923 117.345L162.431 118.356Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M126.742 92.002C126.742 92.002 145.491 94.8559 156.667 107.62C162.372 114.142 167.541 124.011 167.541 124.011H144.68L126.742 92.002Z",
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.68 124.279H167.541C167.637 124.279 167.725 124.225 167.768 124.14C167.815 124.059 167.815 123.959 167.768 123.878L167.765 123.872C167.606 123.571 162.458 113.835 156.854 107.435C145.747 94.7575 126.958 91.7408 126.772 91.7408C126.67 91.7272 126.57 91.7695 126.509 91.8512C126.459 91.9397 126.459 92.0476 126.509 92.136L144.447 124.145C144.495 124.229 144.584 124.28 144.68 124.279ZM167.097 123.75H144.837L127.25 92.3627C130.412 92.9556 146.547 96.4664 156.463 107.795C161.451 113.491 166.077 121.861 167.097 123.75Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M116.593 105.167C120.676 99.1571 123.009 95.35 126.743 92.002C133.713 96.1257 140.13 101.114 145.841 106.847C150.844 111.931 155.078 117.713 158.412 124.011H107.376C107.376 124.011 112.813 110.712 116.593 105.167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.376 124.302H158.411C158.509 124.302 158.6 124.252 158.651 124.169C158.697 124.079 158.697 123.973 158.651 123.884C155.292 117.562 151.039 111.754 146.021 106.638C140.287 100.893 133.849 95.8917 126.859 91.7524C126.753 91.6895 126.617 91.7037 126.526 91.7872C123.312 94.6412 121.125 97.8904 118.103 102.383C117.566 103.209 116.983 104.081 116.353 105.005C112.596 110.509 107.16 123.773 107.107 123.907C107.069 123.995 107.08 124.097 107.136 124.174C107.189 124.255 107.279 124.303 107.376 124.302ZM157.933 123.721H107.813C108.752 121.466 113.477 110.248 116.837 105.33L118.616 102.709C121.562 98.3205 123.709 95.1352 126.783 92.3627C133.651 96.4655 139.984 101.399 145.636 107.051C150.491 112.013 154.629 117.623 157.933 123.721Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M109.237 124.011C109.237 124.011 113.198 114.27 118.121 106.516C123.132 98.6283 127.005 94.856 127.005 94.856C127.005 94.856 132.879 97.6343 142.586 107.138C149.218 113.63 155.378 123.994 155.378 123.994L109.237 124.011Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.237 124.302H155.378C155.489 124.311 155.594 124.254 155.647 124.157C155.699 124.067 155.699 123.956 155.647 123.866C155.643 123.862 155.622 123.827 155.584 123.764C154.915 122.666 149.042 113.025 142.813 106.929C133.188 97.5009 127.215 94.5946 127.157 94.5946C127.045 94.5436 126.914 94.5642 126.824 94.6469C126.823 94.6486 126.814 94.6569 126.8 94.6718C126.461 95.0144 122.663 98.8607 117.899 106.359C113.017 114.026 109.027 123.808 108.992 123.907C108.945 123.99 108.945 124.091 108.992 124.174C109.047 124.255 109.139 124.302 109.237 124.302ZM154.859 123.721H109.674C110.473 121.844 114.072 113.433 118.366 106.673C122.758 99.7561 126.311 95.978 127.063 95.2107C128.131 95.7687 133.772 98.9133 142.382 107.347C148.139 112.98 153.611 121.681 154.859 123.721Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M127.833 127.493H68.2226C68.2226 127.493 65.3818 101.918 66.7876 85.0622C68.1934 68.206 76.9376 55.6626 76.9376 55.6626C76.9376 55.6626 99.0459 61.0798 112.34 82.3536C125.634 103.627 127.833 127.493 127.833 127.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2223 127.784H127.833C127.921 127.792 128.008 127.758 128.066 127.691C128.123 127.632 128.151 127.551 128.142 127.47L128.142 127.469C128.111 127.153 125.776 103.267 112.591 82.1733C99.384 61.0448 77.229 55.4067 77.0073 55.3544C76.8898 55.3199 76.7636 55.3674 76.6982 55.4706C76.6107 55.5811 67.884 68.3104 66.4957 85.0098C65.2236 100.311 67.4922 123.053 67.8811 126.952C67.9166 127.308 67.9365 127.507 67.9365 127.528C67.9515 127.674 68.0752 127.785 68.2223 127.784ZM127.53 127.203H68.4848C68.1932 124.471 65.7665 100.802 67.0907 85.033C68.3973 69.5194 76.0565 57.5166 77.0832 55.9705C79.2823 56.575 99.6815 62.6142 112.095 82.4813C124.386 102.145 127.203 124.296 127.53 127.203Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M127.833 127.493H109.75C109.75 127.493 107.545 104.412 98.6667 83.9344C89.7884 63.4569 76.9551 55.6333 76.9551 55.6333C76.9551 55.6333 99.0634 61.0506 112.358 82.3243C125.652 103.598 127.833 127.493 127.833 127.493Z",
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.75 127.761H127.833H127.921C127.996 127.761 128.068 127.73 128.119 127.675C128.17 127.619 128.196 127.545 128.189 127.47L128.189 127.468C128.155 127.119 125.825 103.258 112.638 82.1851C99.4192 61.0625 77.2759 55.4302 77.0542 55.3779C76.9262 55.3452 76.7937 55.4124 76.745 55.5348C76.6967 55.6543 76.7409 55.7912 76.85 55.8603C76.8524 55.862 76.861 55.8676 76.8757 55.8771C77.521 56.295 89.8786 64.2973 98.4334 84.0451C107.183 104.244 109.488 127.29 109.488 127.523C109.502 127.657 109.615 127.759 109.75 127.761ZM127.542 127.232H109.96C109.698 124.715 107.195 103 98.8767 83.8417C91.7659 67.4097 81.9659 59.0165 78.4134 56.366C83.675 58.0632 101.047 64.7941 112.095 82.4757C124.433 102.198 127.233 124.442 127.542 127.232Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    d: "M107.376 127.493C107.376 127.493 103.608 103.011 98.6667 89.8747C91.4101 70.6934 77.6667 59.6846 77.6667 59.6846C77.6667 59.6846 71.8334 70.6934 70.5209 79.7726C69.6692 85.7711 68.9692 115.583 70.5792 127.226L107.376 127.493Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5792 127.516L107.376 127.784C107.463 127.787 107.547 127.751 107.603 127.685C107.661 127.62 107.687 127.533 107.673 127.447C107.671 127.435 107.66 127.366 107.64 127.245C107.256 124.86 103.597 102.154 98.9234 89.7875C91.7192 70.7399 77.9759 59.5857 77.8359 59.4753C77.7703 59.4185 77.6812 59.3968 77.5967 59.4172C77.512 59.4333 77.4391 59.4867 77.3984 59.5625C77.34 59.6497 71.5184 70.6934 70.2292 79.7319C69.4067 85.5502 68.6775 115.607 70.2934 127.266C70.3136 127.409 70.435 127.515 70.5792 127.516ZM107.038 127.203L70.8359 126.935C69.2725 115.147 69.99 85.5734 70.8125 79.8249C71.9559 71.7397 76.7859 62.0328 77.7484 60.167C86.8943 68.3476 93.9632 78.5724 98.375 90.0025C102.954 102.098 106.559 124.203 107.038 127.203Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M62.4998 75.7041C62.4998 75.7041 74.709 77.814 88.6273 87.4919C112.281 103.941 120.501 127.493 120.501 127.493H58.6265C58.6265 127.493 60.7498 82.528 62.4998 75.7041Z",
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6267 127.761H120.518V127.714C120.605 127.713 120.685 127.671 120.736 127.601C120.786 127.531 120.801 127.442 120.775 127.36C120.773 127.355 120.768 127.342 120.759 127.318C120.341 126.196 111.785 103.234 88.8025 87.2535C74.9775 77.6454 62.675 75.4192 62.5525 75.4192C62.4138 75.3964 62.2803 75.4817 62.2433 75.6168C60.5108 82.3884 58.4283 125.622 58.3408 127.459C58.3403 127.532 58.3674 127.602 58.4167 127.656C58.4674 127.721 58.5445 127.759 58.6267 127.761ZM120.157 127.226H58.9067C59.0875 123.465 61.0825 83.1847 62.7392 76.0063C64.53 76.3666 75.8758 78.9125 88.5167 87.701C110.24 102.814 118.99 124.227 120.157 127.226Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M101.064 127.493C101.064 127.493 99.454 114.648 88.5749 100.326C77.6957 86.0039 62.4999 75.7041 62.4999 75.7041C62.4999 75.7041 55.984 84.8065 53.5632 95.6468C51.1424 106.487 52.9799 127.493 52.9799 127.493H101.064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9857 127.784H101.064C101.137 127.78 101.206 127.749 101.257 127.697C101.311 127.634 101.336 127.552 101.327 127.47C101.309 127.33 99.559 114.339 88.779 100.151C78.0773 86.0658 63.0293 75.7212 62.663 75.4694C62.6604 75.4675 62.6585 75.4662 62.6574 75.4655C62.5265 75.3756 62.3476 75.4066 62.2549 75.5352C62.2539 75.5366 62.2515 75.54 62.2478 75.5453C61.9974 75.9016 55.6163 84.9833 53.2774 95.5825C51.0589 105.636 52.4771 124.602 52.6726 127.216C52.6863 127.4 52.694 127.503 52.694 127.516C52.7089 127.666 52.8344 127.782 52.9857 127.784ZM100.702 127.203H53.254C53.0557 124.75 51.6382 105.725 53.8199 95.693C56.0132 85.9745 61.549 77.5928 62.5699 76.0932C64.5474 77.4882 78.3374 87.3578 88.3182 100.506C98.0715 113.334 100.358 125.116 100.702 127.203Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    d: "M98.264 125.755C98.264 125.755 95.0498 112.596 82.059 97.0995C76.5477 90.5533 70.2243 84.731 63.2406 79.7725C63.2406 79.7725 57.2148 87.6833 55.704 97.7215C54.4673 105.958 54.199 120.722 54.1406 125.755H98.264Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1408 126.046H98.2642C98.349 126.043 98.4281 126.003 98.48 125.936C98.537 125.866 98.5565 125.773 98.5325 125.686C98.5033 125.552 95.155 112.282 82.2692 96.9139C76.7327 90.3537 70.3908 84.5129 63.3925 79.5287C63.2661 79.4421 63.0936 79.4703 63.0017 79.5926C62.9492 79.6566 56.9233 87.6836 55.4183 97.6753C54.1992 105.79 53.9133 120.013 53.8492 125.75C53.848 125.829 53.8797 125.904 53.9367 125.959C53.9909 126.013 54.064 126.044 54.1408 126.046ZM97.8792 125.465H54.4383C54.5083 119.559 54.8 105.702 55.9958 97.7625C57.3375 88.8461 62.3367 81.5282 63.3108 80.1681C70.1669 85.0962 76.3891 90.8452 81.8375 97.2859C93.4458 111.137 97.255 123.25 97.8792 125.465Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    d: "M94.7522 127.493C94.1689 125.209 91.7364 117.345 84.2522 106.016C75.2864 92.4671 62.9956 88.4507 62.9956 88.4507H38.8164V89.3574L55.3364 127.493H94.7522Z",
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3366 127.761H94.7524C94.8481 127.764 94.9387 127.718 94.9916 127.639C95.0434 127.575 95.0609 127.491 95.0383 127.412C94.4724 125.232 92.0399 117.257 84.4974 105.853C75.5841 92.3799 63.2291 88.224 63.1066 88.1833C63.0777 88.1778 63.048 88.1778 63.0191 88.1833H38.8458C38.6999 88.1865 38.5832 88.3053 38.5833 88.4507V89.3574C38.5777 89.3921 38.5777 89.4274 38.5833 89.4621L55.0916 127.598C55.1322 127.697 55.2292 127.761 55.3366 127.761ZM94.3908 127.226H55.4999L39.0849 89.3051V88.7239H62.9374C63.7074 88.9854 75.4558 93.2286 84.0074 106.161C91.1649 116.978 93.6908 124.674 94.3908 127.226Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    d: "M82.0589 127.493C78.7922 121.843 63.6664 97.6402 38.8164 88.4507C38.8164 88.4507 31.0464 105.022 33.2572 127.493H82.0589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2576 127.784H82.0593C82.1629 127.783 82.2583 127.728 82.3101 127.639C82.3622 127.549 82.3622 127.438 82.3101 127.348C79.4751 122.471 64.0576 97.4777 38.9218 88.1777C38.7785 88.1242 38.618 88.1902 38.5543 88.3288C38.5537 88.3302 38.5526 88.3326 38.551 88.336C38.3565 88.7639 30.7901 105.409 32.966 127.523C32.9835 127.67 33.1083 127.782 33.2576 127.784ZM81.5518 127.203H33.526C31.5835 106.667 38.041 90.9503 38.9685 88.8403C63.1068 97.8788 78.1685 121.46 81.5518 127.203Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    d: "M79.0839 127.493C77.5847 124.692 72.0839 116.781 65.5914 109.573C53.3939 96.0766 39.8139 91.6533 39.8139 91.6533C33.508 108.986 35.7772 122.181 35.8997 127.493H79.0839Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9175 127.784H79.0842V127.795C79.1873 127.796 79.2829 127.742 79.3356 127.653C79.3884 127.565 79.3903 127.455 79.3408 127.365C77.9641 124.796 72.5742 116.879 65.8075 109.393C53.6975 95.9777 40.0417 91.4207 39.9017 91.3742C39.7524 91.3309 39.5948 91.4094 39.54 91.5544C34.1967 106.283 35.0133 118.123 35.4567 124.517C35.472 124.736 35.4876 124.95 35.5028 125.158C35.5682 126.053 35.6258 126.843 35.6258 127.499C35.6258 127.575 35.6567 127.649 35.7116 127.702C35.7665 127.756 35.8407 127.785 35.9175 127.784ZM78.5883 127.202H36.18C36.1583 126.491 36.1016 125.649 36.0376 124.701C36.0326 124.627 36.0276 124.552 36.0225 124.476C35.585 118.181 34.78 106.51 39.9892 92.0252C41.9492 92.7285 54.2925 97.518 65.3758 109.765C71.7691 116.845 76.9142 124.296 78.5883 127.202Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    d: "M181.657 127.493L178.863 121.867H88.3766L85.5999 127.493H28.5791V147.366H191.177V127.493H181.657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5793 147.657H191.178C191.336 147.654 191.463 147.524 191.463 147.366V127.493C191.463 127.333 191.333 127.203 191.172 127.203H181.838L179.126 121.739C179.076 121.64 178.975 121.577 178.863 121.576H88.3768C88.2652 121.576 88.1633 121.639 88.1143 121.739L85.4193 127.203H28.5793C28.4182 127.203 28.2876 127.333 28.2876 127.493V147.366C28.2876 147.527 28.4182 147.657 28.5793 147.657ZM190.886 147.076H28.8709V127.784H85.6001C85.7112 127.783 85.8125 127.72 85.8626 127.621L88.5576 122.157H178.683L181.395 127.621C181.445 127.72 181.546 127.783 181.658 127.784H190.886V147.076Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 68.2227,
    y: 127.493,
    width: 32.8417,
    height: 19.8671,
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2223 147.657H101.064C101.225 147.657 101.356 147.527 101.356 147.366V127.493C101.356 127.333 101.225 127.203 101.064 127.203H68.2223C68.0626 127.206 67.9338 127.334 67.9307 127.493V147.366C67.9307 147.527 68.0612 147.657 68.2223 147.657ZM100.772 147.076H68.514V127.784H100.772V147.076Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    d: "M152.502 128.964L174.191 147.366H152.502V128.964Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.503 147.657H174.191C174.313 147.655 174.421 147.579 174.462 147.465C174.504 147.351 174.47 147.224 174.378 147.145L152.689 128.743C152.602 128.672 152.483 128.656 152.38 128.702C152.277 128.748 152.21 128.851 152.211 128.964V147.366C152.211 147.527 152.342 147.657 152.503 147.657ZM173.398 147.075H152.794V129.597L173.398 147.075Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 23.8833,
    y: 131.103,
    width: 44.3392,
    height: 1.9995,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8893 133.393H68.2227C68.3 133.393 68.3742 133.363 68.4289 133.308C68.4836 133.254 68.5143 133.18 68.5143 133.103V131.103C68.5143 130.943 68.3837 130.812 68.2227 130.812H23.8893C23.7282 130.812 23.5977 130.943 23.5977 131.103V133.103C23.6008 133.262 23.7295 133.39 23.8893 133.393ZM67.9252 132.812H24.1752V131.394H67.9252V132.812Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    x: 19.6016,
    y: 136.177,
    width: 48.6267,
    height: 3.52238,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6017 139.985H68.2226C68.3836 139.985 68.5142 139.854 68.5142 139.694V136.177C68.5142 136.017 68.3836 135.887 68.2226 135.887H19.6017C19.4406 135.887 19.3101 136.017 19.3101 136.177V139.694C19.3101 139.854 19.4406 139.985 19.6017 139.985ZM67.9309 139.403H19.8934L19.9167 136.468H67.9309V139.403Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    x: 19.6016,
    y: 138.275,
    width: 48.6267,
    height: 4.38844,
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6018 142.926H68.2227C68.2933 142.927 68.3616 142.9 68.4121 142.851C68.4626 142.802 68.491 142.735 68.491 142.664V138.276C68.491 138.128 68.3709 138.008 68.2227 138.008H19.6018C19.4536 138.008 19.3335 138.128 19.3335 138.276V142.664C19.3335 142.735 19.3619 142.802 19.4124 142.851C19.4629 142.9 19.5312 142.927 19.6018 142.926ZM67.9602 142.397H19.8643V138.543H67.9602V142.397Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    x: 23.8833,
    y: 133.103,
    width: 44.3392,
    height: 3.07481,
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.889 136.439H68.2224C68.293 136.44 68.3613 136.413 68.4118 136.364C68.4623 136.315 68.4907 136.248 68.4907 136.177V133.102C68.4923 133.031 68.4646 132.962 68.4139 132.912C68.3632 132.861 68.294 132.833 68.2224 132.835H23.889C23.8184 132.835 23.7507 132.863 23.7013 132.914C23.6519 132.964 23.625 133.032 23.6265 133.102V136.177C23.6265 136.322 23.7441 136.439 23.889 136.439ZM67.9599 135.91H24.1515V133.364H67.9599V135.91Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    x: 28.5791,
    y: 129.307,
    width: 39.6492,
    height: 1.79606,
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5559 131.37H68.2226C68.3708 131.37 68.4909 131.251 68.4909 131.103V129.307C68.4909 129.236 68.4627 129.168 68.4123 129.118C68.362 129.068 68.2938 129.04 68.2226 129.04H28.5559C28.4848 129.04 28.4165 129.068 28.3662 129.118C28.3159 129.168 28.2876 129.236 28.2876 129.307V131.103C28.2876 131.251 28.4077 131.37 28.5559 131.37ZM67.9601 130.836H28.8418V129.574H67.9601V130.836Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    d: "M85.6001 127.493H111.36L113.74 121.867H88.3768L85.6001 127.493Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5999 127.784H111.36C111.473 127.779 111.573 127.708 111.617 127.604L113.997 121.983C114.043 121.898 114.043 121.795 113.997 121.71C113.943 121.627 113.851 121.576 113.752 121.576H88.3882C88.2767 121.576 88.1748 121.639 88.1257 121.739L85.349 127.365C85.299 127.452 85.299 127.558 85.349 127.644C85.4039 127.73 85.4981 127.782 85.5999 127.784ZM111.15 127.203H86.0665L88.5574 122.157H113.285L111.15 127.203Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    x: 119.305,
    y: 124.883,
    width: 38.4825,
    height: 1.73794,
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    x: 169.997,
    y: 133.585,
    width: 16.1875,
    height: 1.27294,
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    x: 10.8223,
    y: 141.06,
    width: 57.4058,
    height: 6.30656,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8224 147.657H68.2224C68.3835 147.657 68.5141 147.527 68.5141 147.366V141.06C68.5141 140.899 68.3835 140.769 68.2224 140.769H10.8224C10.6613 140.769 10.5308 140.899 10.5308 141.06V147.366C10.5308 147.527 10.6613 147.657 10.8224 147.657ZM67.9308 147.076H11.1141V141.35H67.9308V147.076Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    d: "M181.658 129.231H152.491C152.387 129.247 152.283 129.2 152.226 129.112C152.169 129.024 152.169 128.91 152.226 128.822C152.283 128.734 152.387 128.687 152.491 128.702H181.658C181.762 128.687 181.865 128.734 181.923 128.822C181.98 128.91 181.98 129.024 181.923 129.112C181.865 129.2 181.762 129.247 181.658 129.231Z",
    fill: "#231F20"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_575_2703",
    x1: 0,
    y1: 202,
    x2: 202,
    y2: 202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D0202",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D0202",
    stopOpacity: 0.497569
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurImg2);
export default __webpack_public_path__ + "static/media/our-img2.947c577bcfbda213de0903e717d126fb.svg";
export { ForwardRef as ReactComponent };